export const MEDIA_PACKAGE_CONFIG_FILE_TYPE = 'guidesofia-media-package-client-configuration';
export const MEDIA_PACKAGE_CONFIG_SCHEMA_VERSION = 1;
export const MEDIA_PACKAGE_RENDERER_VERSION = 1;

const jsonSafe = (value) => JSON.parse(JSON.stringify(value));

export const createMediaPackageConfigFile = ({ guideKey, packageData, assets = {} }) => ({
  fileType: MEDIA_PACKAGE_CONFIG_FILE_TYPE,
  schemaVersion: MEDIA_PACKAGE_CONFIG_SCHEMA_VERSION,
  rendererVersion: MEDIA_PACKAGE_RENDERER_VERSION,
  guideKey,
  guide: {
    id: packageData?.guide?.guide_id || '',
    title: packageData?.guide?.guide_title || packageData?.config?.guide_title || '',
    language: packageData?.guide?.language || packageData?.config?.output_language || '',
  },
  exportedAt: new Date().toISOString(),
  packageData: jsonSafe(packageData),
  assets: jsonSafe(assets),
});

export const parseMediaPackageConfigFile = (value, expectedGuideKey) => {
  if (!value || typeof value !== 'object') {
    throw new Error('The selected file is not a Media Package client configuration.');
  }
  if (value.fileType !== MEDIA_PACKAGE_CONFIG_FILE_TYPE) {
    throw new Error('The selected JSON is not a versioned Media Package client configuration.');
  }
  if (Number(value.schemaVersion) !== MEDIA_PACKAGE_CONFIG_SCHEMA_VERSION) {
    throw new Error(`Configuration schema version ${value.schemaVersion || 'unknown'} is not supported.`);
  }
  if (Number(value.rendererVersion) > MEDIA_PACKAGE_RENDERER_VERSION) {
    throw new Error(`This configuration requires renderer version ${value.rendererVersion}. Update the Builder before restoring it.`);
  }
  if (!value.guideKey || value.guideKey !== expectedGuideKey) {
    throw new Error('This configuration belongs to a different client guide or language.');
  }
  if (!value.packageData?.config || !value.packageData?.guide) {
    throw new Error('The configuration file is incomplete.');
  }
  return {
    packageData: jsonSafe(value.packageData),
    assets: jsonSafe(value.assets || {}),
    rendererVersion: Number(value.rendererVersion) || 1,
  };
};
